import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=04ef67ca&"
import script from "./Unauthorized.ts?vue&type=script&lang=ts&"
export * from "./Unauthorized.ts?vue&type=script&lang=ts&"
import style0 from "./Unauthorized.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports